import { useCallback, useEffect, useState } from "react";


const useOwnerRelationState = (defaultCardRelation = "") => {
	const [isOwner, setIsOwnerState] = useState(defaultCardRelation === '本人');
	const [cardRelation, setCardRelation] = useState(
		defaultCardRelation === "本人" ? "本人" : ""
	);

	const setIsOwner = useCallback((value) => {
			setIsOwnerState(value);
			// isOwner 改變 → 自動對應 cardRelation
			setCardRelation(value ? "本人" : "");
		},
		// eslint-disable-next-line
		[]);

	const updateCardRelation = useCallback((value) => {
		setCardRelation(value);
	}, []);

	// 一次轉換 defaultValue
	useEffect(() => {
			setIsOwner(defaultCardRelation === '本人');
			setCardRelation(defaultCardRelation)
		},
		// eslint-disable-next-line
		[defaultCardRelation]);


	return {
		isOwner,
		cardRelation,
		setIsOwner,
		updateCardRelation
	};
};

export default useOwnerRelationState;